import React, { createContext, FC, useContext} from 'react'
import { analyticsClient } from './client'

type AnalyticsContextType = typeof analyticsClient
type Props = {
  children: React.ReactNode
}

export const useAnalytics = () => {
  return useContext(AnalyticsContext)
}

export const AnalyticsContext = createContext<AnalyticsContextType>(analyticsClient)

const AnalyticsContextProvider: FC<Props> = ({ children }) => {
  return (
    <AnalyticsContext.Provider value={analyticsClient}>
      {children}
    </AnalyticsContext.Provider>
  )
}

export default AnalyticsContextProvider
